import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';
import { useTheme } from '../../../../../ThemeContext';
import styles from './RecentSearches.module.scss';


interface Props {
  onQueryChange: any;
}

const RecentSearches = ({ onQueryChange }: Props) => {
  const { t } = useTranslation('search');

  const recentSearchTerms = JSON.parse(localStorage.getItem('searchHistory') || '[]');

  const limitedRecentSearches = recentSearchTerms.slice(0, 5);
  const { universalStyles } = useTheme();
  return (
    <div className={styles.container}>
      <h1 className={styles.title} style={universalStyles.primaryTextColor}>
        {t('recent_searches')}
      </h1>
      <div className={styles.recentSearchButton}>
        {limitedRecentSearches.length > 0 ? (
          limitedRecentSearches.map((searchTerms: string, index: number) => (
            <Button
              key={index}
              color="recentSearchButton"
              onClick={() => {
                onQueryChange(searchTerms);
              }}
              variant="contained"
              size="small"
              label={searchTerms}
            />
          ))
        ) : (
          <p style={universalStyles.primaryTextColor}>{t('search_history_empty')}</p>
        )}
      </div>
    </div>
  );
};

export default RecentSearches;
